module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/280.09bece87.png";